import { toItem as toFile } from '../../private-site/mappers/item';
import { toFolder } from '../../private-site/mappers/folder';
import { ItemKind } from '../../../constants/ItemKind';
const getItemMapper = kind => {
  switch (kind) {
    case ItemKind.File:
      return toFile;
    case ItemKind.Folder:
      return toFolder;
    case 'external':
    case 'public':
      return srcInfo => ({
        ...srcInfo,
        tags: [...(srcInfo.tags || []), '_fav']
      });
    default:
      throw new Error("Unsupported item type " + kind);
  }
};
export function toItem(itemData, settings, thumbnailSizes) {
  const mapper = getItemMapper(itemData.src_type);
  return {
    id: itemData.id,
    ...(itemData.src_info ? mapper(itemData.src_info, settings, thumbnailSizes) : {}),
    siteMediaToken: itemData.token
  };
}